import React, { useMemo } from 'react'
import { Descriptions, Modal, Table } from 'antd'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import { DATE_TIME_FORMAT } from '../../../../../constants/Define'
import { StatusComponent } from '../../../common/component/Index'
import { generateStringId } from "../../../../../utils/orders";

const { Item } = Descriptions


const Schedules = (props) => {
    const {
        data,
        handleOk,
        handleCancel,
        t
    } = props

    const columns = useMemo(() => ([
        {
            title: t('item.promotions.scheduleTypeHeader'),
            dataIndex: 'scheduleType',
            key: 'scheduleType',
            render: (data, record) => data ? t(`item.promotions.scheduleType.${data.toLowerCase()}`) : '',
        },
        {
            title: t('item.promotions.startDate'),
            dataIndex: 'startDate',
            key: 'startDate',
            render: (date, record) => moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
        },
        {
            title: t('item.promotions.endDate'),
            dataIndex: 'endDate',
            key: 'endDate',
            render: (date, record) => moment(moment.utc(date).toDate()).format(DATE_TIME_FORMAT.DATE_TIME)
        },
    ]), [data])

    return (
        <Modal
            title={ t('item.promotions.titleModalSchedules') }
            width={ 1000 }
            visible={ !!data }
            onOk={ handleOk }
            onCancel={ handleCancel }
            footer={ null }
        >
            <Descriptions bordered title={ t('item.promotions.promotionInfo') } bordered column={ 2 } size='middle' className="m-b">
                <Item label={ t('item.promotions.campaignName') }>{ data.infoCode.campaignName }</Item>
                <Item label={ t('item.promotions.bundleName') }>{ data.infoCode.bundleName }</Item>
                <Item label={ t('item.promotions.promotionCode') }>{ data.infoCode.promotionCode }</Item>
                <Item label={ t('item.promotions.active') }>
                    <StatusComponent color={ data.infoCode.isActive ? 'green' : 'red' }
                                     label={ data.infoCode.isActive ? t('item.promotions.active') : t('item.promotions.deactive') }/>
                </Item>
            </Descriptions>
            <Table
                className="table-history m-t"
                dataSource={ data.list }
                columns={ columns }
                scroll={ { y: 250 } }
                rowKey={record => (generateStringId(10) + record.orderCode)}
                pagination={ { defaultPageSize: 5000 } }
                bordered
            />
        </Modal>
    )
}

export default withTranslation()(Schedules)
